<template>
  <v-card>
    <service-header :service="service" :scope="scope"></service-header>
    <v-divider></v-divider>
    <template v-if="isOffer">
      <service-meta :service="service"></service-meta>
      <service-content :service="service"></service-content>
      <v-divider></v-divider>
    </template>
    <service-actions :service="service"></service-actions>
  </v-card>
</template>

<script>
  import Service from '@/api/service'
  import ServiceHeader from './Header'
  import ServiceMeta from './Meta'
  import ServiceContent from './Content'
  import ServiceActions from './Actions'
  export default {
    components: {
      ServiceHeader,
      ServiceMeta,
      ServiceContent,
      ServiceActions
    },
    props: {
      service: {
        type: Object,
        required: true
      },
      scope: {
        type: String,
        required: true
      }
    },
    computed: {
      isOffer () { return Service.isOfferScope(this.scope) }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/service/Card.vue